import type Highcharts from "highcharts";
import React from "react";
import { color } from "@ui";
import { zIndexChart } from "@ui/Highcharts/BetterHighcharts";
import type { Period } from "@ui/Highcharts/hooks/usePeriod";

const PLOTLBAND_ID = "fault-event-plotband";

const useFaultEventPlotBands = ({
  faultEventPeriod,
  projectExtremes,
  chartRef,
}: {
  faultEventPeriod: Period;
  projectExtremes: Period;
  chartRef: React.RefObject<Highcharts.Chart>;
}) => {
  React.useLayoutEffect(() => {
    const chart = chartRef.current;
    if (!chart) {
      throw new Error("chart not found");
    }
    const xAxis = chart.xAxis[0];
    const xAxisNavigator = chart.xAxis[1];
    if (xAxis === undefined || xAxisNavigator === undefined) throw new Error("Missing xAxis");

    xAxis.removePlotBand(PLOTLBAND_ID);
    xAxisNavigator.removePlotBand(PLOTLBAND_ID);

    const intervals = [
      { from: projectExtremes.from, to: faultEventPeriod.from },
      { from: faultEventPeriod.to, to: projectExtremes.to },
    ].filter(({ from, to }) => from < to);

    for (const { from, to } of intervals) {
      xAxis.addPlotBand({
        from,
        to,
        id: PLOTLBAND_ID,
        zIndex: zIndexChart.plotBands,
        color: color.shadowColor,
      });
      xAxisNavigator.addPlotBand({
        from,
        to,
        id: PLOTLBAND_ID,
        zIndex: zIndexChart.plotBands,
        color: color.shadowColor,
      });
    }
  }, [
    chartRef,
    projectExtremes.from,
    projectExtremes.to,
    faultEventPeriod.from,
    faultEventPeriod.to,
  ]);
};

export default useFaultEventPlotBands;
